import Caseone from "../containers/caseone";

export const routes = [{ path: "/", component: Caseone }];
